// @flow
import env from '../../environment';
import {postCreator, getCreator} from '../../http';

export const endpoints = Object.freeze({
  GENERATE_PRODUCT_CATALOGUE: `${env.baseApiUrl}/im/admin/product/build-product-catalogue`,
  GET_PRODUCT_CATALOGUE: `${env.baseApiUrl}/im/admin/product/product-catalogue`,
});

export const generateProductCatalogueApi = postCreator(
  endpoints.GENERATE_PRODUCT_CATALOGUE
);

export const getProductCatalogueApi = getCreator(
  endpoints.GET_PRODUCT_CATALOGUE
);
